import React from 'react';
import SEO from '../components/SEO';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="Disclaimer | Newsmedia Association of India"
        description="Legal disclaimer for Newsmedia Association of India (NAI). Understand the limitations of information provided on our website."
        keywords="Disclaimer, NAI Disclaimer, Legal Notice, Media Liability"
      />
      
      {/* Header */}
      <section className="bg-blue-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Disclaimer</h1>
          <p className="text-blue-100">Last Updated: May 2, 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-blue max-w-none text-gray-700 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">General Information</h2>
              <p>
                The information provided by the Newsmedia Association of India ("NAI", "we", "us", or "our") on naiindia.in (the "Site") is for general informational purposes only. All information on the Site is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Site.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Professional Advice Disclaimer</h2>
              <p>
                The Site cannot and does not contain legal or professional advice. The information is provided for general informational and educational purposes only and is not a substitute for professional advice. Accordingly, before taking any actions based upon such information, we encourage you to consult with the appropriate professionals. The use or reliance of any information contained on this Site is solely at your own risk.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">External Links Disclaimer</h2>
              <p>
                The Site may contain (or you may be sent through the Site) links to other websites or content belonging to or originating from third parties or links to websites and features in banners or other advertising. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us. We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third-party websites linked through the site.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">News and Reporting Disclaimer</h2>
              <p>
                NAI provides a platform for journalists and media professionals to share news and reports. The views and opinions expressed in such reports are those of the authors and do not necessarily reflect the official policy or position of NAI. NAI is not responsible for the accuracy or authenticity of user-submitted news content.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">"Use at Your Own Risk" Disclaimer</h2>
              <p>
                The information on this Site is provided with the understanding that NAI is not herein engaged in rendering legal, accounting, tax, or other professional advice and services. As such, it should not be used as a substitute for consultation with professional accounting, tax, legal, or other competent advisers.
              </p>
              <p className="mt-4">
                In no event shall NAI or its affiliates, partners, agents, or employees be liable for any special, incidental, indirect, or consequential damages whatsoever arising out of or in connection with your access or use or inability to access or use the Site.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;
